import React from "react";
import SuccessMessage from "../../messages/SuccessMessage";
import DialogConfirmButtons from "../../common/dialogConfirmButtons/DialogConfirmButtons";
import StepTitle from "../../common/stepTitle/StepTitle";
import Pod from "carbon-react/lib/components/pod";

const IssuePasswordStep = ({ busy, state, onClose }) => {
  const dialogButtons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Close"
      confirmBtnAutoFocus={true}
      onConfirm={onClose}
      omitCancelBtn={true}
    />
  );

  const disclaimerText =
    "The following password must be relayed to the user VERBALLY and is valid for one login attempt only " +
    " during which, the user will be prompted to provide a new password.";

  const disclaimer = (
    <StepTitle className="reset-password-disclaimer" title={disclaimerText} />
  );

  const newPassword = (
    <Pod>
      <div className="reset-password-temp-password">
        <span>{state.password}</span>
      </div>
    </Pod>
  );

  return (
    <>
      <div className="reset-password-dialog-body">
        <SuccessMessage
          className="reset-password-success-message"
          message={`User's password was successfully reset.`}
        />
        {disclaimer}
        {newPassword}
      </div>
      {dialogButtons}
    </>
  );
};

export default IssuePasswordStep;
